// extracted by mini-css-extract-plugin
export default {"messageWrapper":"ContactSuccess_messageWrapper__aZBEH","backButton":"ContactSuccess_backButton__otumT"};